import { render, staticRenderFns } from "./LongTextField.vue?vue&type=template&id=3d60acec"
import script from "./LongTextField.vue?vue&type=script&lang=js"
export * from "./LongTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports